export default [
  {
    srno: "1",
    category: "MensBottom",
    subcategory: "01"
  },
  {
    srno: "2",
    category: "WomensBottom",
    subcategory: "02"
  },
  {
    srno: "2",
    category: "Ethnic Wear",
    subcategory: "02"
  },
  {
    srno: "2",
    category: "Indo-western",
    subcategory: "02"
  }
];
